<template>
    <div>
        <el-upload class="upload-demo" drag action="" multiple style="width: 100%" :show-file-list="false"
            :accept="accept" :http-request="uploadAction" :on-error="uploadError"
            :disabled="sList.length > 50 ? true : false" :limit="50" :on-exceed="uploadExceed" :file-list="wList.concat(sList)">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                将照片拖到此处，或
                <em>点击选择照片</em>
            </div>
        </el-upload>
        <div class="list-wrap">
            <el-row :gutter="20" type="flex">
                <el-col v-if="wList.length > 0" :sm="eList.length > 0 ? 12 : 24">
                    <el-card>
                        <div slot="header" class="c-head color-warning">
                            <span>上传中&待上传（{{wList.length}}张）</span>
                            <el-button size="mini" type="primary" icon="el-icon-upload" :loading="uploading" @click="uploadPhoto">点击上传</el-button>
                        </div>
                        <el-table :data="wList" size="mini">
                            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="type" label="格式"></el-table-column>
                            <el-table-column prop="size" label="大小">
                                <template slot-scope="{row} = scope">{{ (row.size / 1024 / 1024).toFixed(2)
                                }}M</template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="{row} = scope">
                                    <el-progress :percentage="row.progress || 0" :show-text="false"></el-progress>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col v-if="eList.length > 0" :sm="wList.length > 0 ? 12 : 24">
                    <el-card>
                        <div slot="header" class="color-danger">上传失败（{{eList.length}}张）</div>
                        <el-table :data="eList" size="mini">
                            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="type" label="格式"></el-table-column>
                            <el-table-column prop="size" label="大小">
                                <template slot-scope="{row} = scope">{{ (row.size / 1024 / 1024).toFixed(2)
                                }}M</template>
                            </el-table-column>
                            <el-table-column prop="err" label="原因" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
            <el-card v-if="sList.length > 0" class="MT20">
                <div slot="header" class="color-success">上传成功（{{sList.length}}张）</div>
                <el-row :gutter="20" type="flex" class="photo-list">
                    <el-col v-for="(item, index) in sList" :key="index">
                        <div class="item">
                            <el-image :src="item.url" fit="cover" :preview-src-list="previewList"></el-image>
                            <div class="info">
                                <div class="name ellipsis">{{ item.name }}</div>
                                <div class="flex">
                                    <div class="size">{{ (item.size / 1024).toFixed(2) }}M</div>
                                    <el-button type="text" @click="sList = sList.filter((v, i) => i != index);$message.success('删除成功！');"
                                        size="small">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div class="MT20">
            <el-button type="primary" @click="submitForm()" :disabled="sList.length > 0 ? false : true"
                :loading="btnLoading">确认提交</el-button>
            <span class="color-danger ML10">点击“确认提交”将忽略失败目录中的照片，结束本次上传任务。</span>
        </div>
    </div>
</template>

<script>
import { uploadPhoto } from '@/assets/js/commonApi.js';
export default {
    props: {
        formData: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            progress: '',
            wList: [], //待上传文件列表
            sList: [], //上传成功文件列表
            eList: [], //上传失败列表
            accept: 'image/jpeg',
            previewList: [],
            btnLoading: false,
            uploading: false
        };
    },
    watch: {
        sList: {
            immediate: true,
            handler(value) {
                this.previewList = value.map(v => v.url)
            }
        }
    },
    methods: {
        //组件上传失败
        uploadError(err, file, fileList) {
            console.log(err);
        },
        //文件超出个数限制时的钩子	
        uploadExceed(files, fileList){
            console.log(fileList)
            this.$message.warning(`当前限制选择 50 张照片，本次选择了 ${files.length} 张照片，共选择了 ${files.length + fileList.length} 张照片`);
        },
        fileJson(file) {
            return {
                name: file.name,
                size: file.size,
                type: file.type,
            }
        },
        setProgress(ev, _uuid) {
            const progress = Math.floor((ev.loaded / ev.total) * 20);

            this.wList.map((v, i) => {
                if (v.uuid == _uuid) {
                    v.progress = progress;
                    if (Math.floor((ev.loaded / ev.total)) == 1) {
                        const t = setInterval(() => {
                            if (v.progress && v.progress < 99) {
                                v.progress += 1;
                            } else {
                                clearInterval(t);
                            }
                        }, 1000)
                    }
                }
            })
        },
        //上传事件
        async uploadAction(req) {
            const { file } = req;
            const _minSize = 1024 * 1024, _maxSize = 1024 * 1024 * 30;
            let _accept = this.accept.split(',') || [];

            _accept.map((item, index) => {
                _accept[index] = item.trim();
            })
            if (!_accept.find(v => v == file.type)) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '图片格式错误',
                });
                return;
            }
            if (file.size < _minSize) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '图片大小不足1M',
                });
                return;
            }
            if (file.size > _maxSize) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '图片大小大于30M',
                });
                return;
            }
            if (this.wList.find(v => v.name == file.name) || this.sList.find(v => v.name == file.name)) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '图片名称重复（该图片待上传或已上传过）',
                });
                return;
            }
            
            const _uuid = this.$utils.uuid();
            this.wList.push({
                ...this.fileJson(file),
                progress: 0,
                uuid: _uuid,
                file: file
                // uploadLoading: true
            });
        },
        async uploadPhoto(){
            // this.wList.map(async (v,i) => {
            //    setTimeout(async () => {
                await this.uploadRequest(this.wList[0].file,this.wList[0].uuid);
            //    },2000+i*100)
                
            // })
        },
        async uploadRequest(file, _uuid){
            this.uploading = true;
            const fileData = new FormData();
            fileData.append('file', file);

            const res = await uploadPhoto(
                fileData,
                {
                    ...this.formData,
                    shootingTime: this.$utils.formatDate(file.lastModified, 'yyyy-MM-dd HH:mm:ss'),
                },
                (ev) => {
                    this.setProgress(ev, _uuid)
                }
            )
                .catch(() => {
                    this.eList.push({
                        ...this.fileJson(file),
                        err: '上传失败',
                    });
                })
                .finally(() => {
                    this.wList.map((v, i) => {
                        if (v.uuid == _uuid) {
                            v.progress = 99;
                            const t = setTimeout(() => {
                                // this.wList[i].uploadLoading = false;
                                clearInterval(t);
                            }, 800);
                        }
                    })
                    const t1 = setTimeout(async () => {
                        this.wList = this.wList.filter(item => item.name != file.name)
                        this.uploading = false;
                        
                        if( this.wList.length > 0 ){
                            await this.uploadRequest(this.wList[0].file,this.wList[0].uuid);
                        }

                        clearInterval(t1);
                    }, 1000);
                });

            const { state, result, msg } = res.data;
            if (state == 1) {
                if (result.status == 1) {
                    this.sList.push({
                        ...result,
                        name: file.name
                    });
                } else if (result.status == 2) {
                    this.eList.push({
                        ...this.fileJson(file),
                        err: msg || '重复上传',
                    });
                } else {
                    this.eList.push({
                        ...this.fileJson(file),
                        err: msg || '上传失败',
                    });
                }
            } else {
                this.eList.push({
                    ...this.fileJson(file),
                    err: msg || '上传失败',
                });
            }
        },

        // 提交
        submitForm() {
            if (this.wList.length > 0) {
                this.$confirm('存在上传中或待上传的图片，提交后将无法保存这些图片，确认提交吗？', '提交', {
                    confirmButtonText: '确认提交',
                    cancelButtonText: '稍后提交',
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    center: true
                }).then(() => {
                    this.submitAction();
                }).catch(() => {

                });
            } else {
                this.submitAction();
            }
        },
        submitAction() {
            this.btnLoading = true;
            const _photoIds = this.sList.map(v => v.photoId);
            this.$request({
                url: "/photo/confirmUpload",
                method: "POST",
                params: {
                    photoIds: _photoIds.toString(),
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$router.go(-1);
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload,
::v-deep .el-upload-dragger {
    width: 100%;
    height: 100px;

    .el-icon-upload {
        margin: 10px 0 5px 0;
        font-size: 40px;
        line-height: 40px;
    }
}

.list-wrap {
    .el-col {
        margin-top: 20px;

        .el-card {
            height: 100%;
            .c-head{
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .file-list {
                .file {
                    margin: 8px 0;
                }
            }
        }
    }
}

.photo-list {
    flex-wrap: wrap;

    .el-col {
        width: 200px;

        .item {
            border: 1px #eee solid;
            border-radius: 4px;
            overflow: hidden;

            .el-image {
                width: 100%;
                height: 150px;
            }

            .info {
                padding: 10px;

                .flex {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            }
        }

    }
}

@media screen and (max-width: 768px) {
    .el-row {
        flex-wrap: wrap;
    }
}
</style>
